import api from "@/services/api";
import { useAppStore } from "@/stores/appStore";

const getActiveUser = () => useAppStore().active.user;

export default {
  getDatas() {
    // const user = getActiveUser();
    // const params = user?.id ? { user_id: user.id } : {};
    const params = {};
    return api.get(`/api/v1/editor/datas`, { params });
  },

  getCollectionData(collectionId, params = {}) {
    let id;

    console.log('getCollectionData called with collectionId:', collectionId);
  
    // 1. Als het een object is, proberen we collectionId.id te gebruiken
    // if (collectionId && typeof collectionId === 'object') {
    //   if (typeof collectionId.id === 'number') {
    //     id = collectionId.id || collectionId;
    //   } else {
    //     id = collectionId.collection;
    //   }
    // } else {

     
    // }

    id = collectionId.collection || collectionId.id || collectionId;
  

    // Bouw de URL
    let url = `/api/v1/editor/datas?collection_id=${id}`;
    if (Object.keys(params).length) {
      const queryParams = new URLSearchParams(params).toString();
      url += `&${queryParams}`;
    }
  
    return api.get(url);
  },
  

  createData(collectionId, data) {
    const user = getActiveUser();
    const params = { collection_id: collectionId };
    if (user?.id) params.user_id = user.id;

    return api.post(`/api/v1/editor/datas`, data, { params });
  },

  getData(id, collectionId) {

    if( !id || !collectionId) {
      return Promise.reject(new Error("ID and Collection ID are required"));
    }
    const user = getActiveUser();
    const params = {
      id,
      collection_id: collectionId,
    };
    if (user?.id) params.user_id = user.id;

    return api.get(`/api/v1/editor/data`, { params });
  },

  updateData(data) {
    const user = getActiveUser();
    const params = {};
    if (user?.id) params.user_id = user.id;

    return api.put(`/api/v1/editor/data`, data, { params });
  },

  deleteData(id, collectionId) {
    const user = getActiveUser();
    const params = {
      id,
      collection_id: collectionId,
    };
    if (user?.id) params.user_id = user.id;

    return api.delete(`/api/v1/editor/data`, { params });
  },
};
